/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Todo from "./Todo";
import PieChartt from "./PieChart";
import Chart from "./Chart";
import DateRangeFilter from "./DateRangeFilter";
import WebsiteHits from "./WebsiteHits";
import AvgLife from "./AvgLife";
import { fetchCoachProfileByEmailId } from "../../redux/Slices/profileSettingsSlice";
import { UnitContext } from "../../hooks/UnitProvider";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { CONSTANTS } from "../../utils/Constant/Constant";
import useCustomTranslation from "../../hooks/useCustomTranslation";

const Home = ({ logout }) => {
  const { trans } = useCustomTranslation();
  const dispatch = useDispatch();
  const { toggleUnit } = useContext(UnitContext);
  const { clientAnalytics, loading } = useSelector((state) => state.dashboard);
  const { profileData, error } = useSelector((state) => state.profile);

  const [startDate, setStartDate] = useState(() => {
    const date = new Date();
    return new Date(date.getFullYear(), date.getMonth(), 1);
  });

  const [endDate, setEndDate] = useState(() => {
    const date = new Date();
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  });

  const handleDateChange = (newStartDate, newEndDate) => {
    if (newStartDate) setStartDate(newStartDate);
    if (newEndDate) setEndDate(newEndDate);
  };

  const hits = [
    { name: "Mon", value: 200 },
    { name: "Tue", value: 212 },
    { name: "Wed", value: 111 },
    { name: "Thr", value: 90 },
    { name: "Fri", value: 70 },
    { name: "Sat", value: 300 },
    { name: "Sun", value: 400 },
  ];

  const client = [
    { name: profileData?.displayName, value: clientAnalytics?.activeClients },
  ];
  // Get both possible email IDs from localStorage
  const coachEmailId = localStorage.getItem("coachemail");
  const emailId = localStorage.getItem("userName");

  // Determine which email to use (coachemail takes priority)
  const emailToUse = coachEmailId || emailId;

  // Fetch profile on component mount
  useEffect(() => {
    if (emailToUse) {
      dispatch(fetchCoachProfileByEmailId({ emailId: emailToUse, toggleUnit }));
    }
  }, [dispatch]);

  useEffect(() => {
    if (profileData?.status === "Inactive") {
      logout();
      // Display a success toast notification
      toast.error(
        <div>
          <strong>{trans("Common.inactiveCoach")}</strong>
        </div>,
        {
          position: "top-center",
          zIndex: 9999,
          toastId: "error-toast",
          autoClose: CONSTANTS.TOAST_DURATION_LONG,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        }
      );
    }
    if (error?.status === 404) {
      logout();
      // Display a error toast notification
      toast.error(
        <div>
          <strong>{error?.data?.message}</strong>
        </div>,
        {
          position: "top-center",
          zIndex: 9999,
          toastId: "error-toast",
          autoClose: CONSTANTS.TOAST_DURATION_LONG,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        }
      );
    }
  }, [profileData, error]);

  return (
    <div className="home-container">
      {/* Welcome Section */}

      {/* Main Layout */}
      <div className="home-layout">
        {/* Left Column: Todo, Website Hits, Avg Life */}
        <div className="left-column">
          <div className="widget-container">
            <Todo />
          </div>
          <div className="widget-container">
            <Chart startDate={startDate} endDate={endDate} />
          </div>
          <div className="widget-container">
            <AvgLife List={client} loadingdata={loading} />
          </div>
        </div>

        {/* Right Column: Date Filter, PieChart, Chart */}
        <div className="right-column">
          <div className="date-filter-container">
            <DateRangeFilter
              startDate={startDate}
              endDate={endDate}
              setStartDate={(date) => handleDateChange(date, null)}
              setEndDate={(date) => handleDateChange(null, date)}
            />
          </div>
          <div className="widget-container">
            <PieChartt startDate={startDate} endDate={endDate} />
          </div>
          <div className="widget-container">
            <WebsiteHits data={hits} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
